import styled from "styled-components";

export const WadeStyled = styled.div`
    width: ${(props) => props.width ? props.width : '7rem' };
    height: ${(props) => props.height ? props.height : '10rem' };

`